import { getRealStartEndDate, getShowTimeDifferenceLabel as sharedGetShowTimeDifferenceLabel, isEarlyShow as sharedIsEarlyShow, parseTimeOfPerformance as sharedParseTimeOfPerformance, type ShowDates } from "shared/utils/showDateUtils";
import { timeDifferenceStringsFromResx } from "./momentutils";

export { getRealStartEndDate };
export { formatTimeOfPerformance } from "shared/utils/showDateUtils";

export const getShowTimeDifferenceLabel = (dates: ShowDates) =>
  sharedGetShowTimeDifferenceLabel(dates, timeDifferenceStringsFromResx());

// These bind the shared, config parameterized helpers to the in-night threshold from serverReference.
export const isEarlyShow = (startDate: moment.Moment) =>
  sharedIsEarlyShow(startDate, serverReference.constants.appointment.maxInNightOfHour);

export const parseTimeOfPerformance = (dates: ShowDates) =>
  sharedParseTimeOfPerformance(dates, serverReference.constants.appointment.maxInNightOfHour);
